import React, {useEffect,useContext,useCallback} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";
import Popup from "../../Helpers/Popup";
import {ComponentContext} from "../../../contexts";
import { useDropzone } from "react-dropzone";
import FileSmall from "./FileSmall";
import generateUid from "../../../utils/generateUid";
import FileBig from "./FileBig";
import axios from "../../../utils/axios";
import ContextButton from "../../Helpers/ContextButton";
import LinksUploader from "./LinksUploader";

function BigMode(props) {
  const store = useLocalObservable(() => ({
    drag_over:false,
    drag_over_left:false,
    show_links_uploader:false,
    replace_left:{
      progress:{
        active:false,
      },
      tmp_file:null,
    },
  }));
  let _scrollerRef=null;
  const onDragEnter=()=>{
    runInAction(()=> {
      store.drag_over = true;
    });
  };
  const onDragLeave=()=>{
    runInAction(()=> {
      store.drag_over = false;
    });
  };
  const onLinks=(links)=>{

  };
  const onDrop = useCallback((files) => {
    runInAction(()=>{
      store.drag_over=false;
      console.log(files);
      for(let i in files) {
        compStore.data.push({
          sys_uid:generateUid(),
          uploading:true,
          uploading_file:files[i]
        })
      }
      compStore.prepareSort();
      compStore.uploadNext(false);
    });
    moveScroll();
  });
  const onDropLeft = useCallback((files) => {
    if(files && files.length === 1) {
      compStore.replaceCurFile(files[0]);
    }
  });

  const moveScroll=()=> {
    if (_scrollerRef) {
      setTimeout(() => {
        _scrollerRef.scrollTop = _scrollerRef.scrollHeight + _scrollerRef.getBoundingClientRect().height;
      }, 100);
    }
  };


  const compStore=useContext(ComponentContext);

  const {getRootProps, getInputProps, isDragActive, open} = useDropzone({
    ...compStore.options.uploadOptions,
    onDrop,
    onDragLeave,
    onDragEnter,
    noClick:true,
    noKeyboard:true
  });

  const LeftZone = useDropzone({
    ...compStore.options.uploadOptions,
    onDrop:(files)=>{
      onDropLeft(files);
      runInAction(()=>{ store.drag_over_left=false; });
    },
    onDragLeave:()=>{ runInAction(()=>{ store.drag_over_left=false; }); },
    onDragEnter:()=>{ runInAction(()=>{ store.drag_over_left=true; }); },
    noClick:true,
    noKeyboard:true
  });

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  return (
    <div>
      <Popup disablePaddings={true} showed={true} onHide={()=>{ props.onClose(); compStore.clearSelection(); }}>
        <div style={{width: 1000, height: 600}}  className="pr">

          <div className="up12 splice solid1-bottom bo-w2" style={{height:50}}>
            <div className="cell s-2 s-middle pr">
              <span className="dib hpadd10 vpadd10 pointer" onClick={open}>
                <span className="mdi mdi-plus fs20 vam"></span>
                <span className="pleft5">Добавить файл</span>
              </span>
              <ContextButton items={[
                  {title:"Загрузить по ссылке", onClick:()=>{ store.show_links_uploader=true; }},
                ]}>{(ret)=>{
                  return (
                    <span className="dib vam pr">
                      <span {...ret.buttonProps} className="mdi pointer mdi-dots-vertical dib vam fs24"></span>
                      {ret.Context}
                    </span>
                  )
                }}
              </ContextButton>
              {store.show_links_uploader?(
                <div className="pa pa-tl bg-w1 padd5 shadow z4">
                  <LinksUploader onClose={(scroll)=>{ runInAction(()=>{ store.show_links_uploader=false; if(scroll){ moveScroll(); } }); }} />
                </div>
              ):null}
            </div>
            <div className="cell s-auto fs17 bold s-middle tac vpadd10">
              Редактирование галереи
            </div>
            <div className="cell s-2 tar s-middle">
              <span className="dib hpadd10 vpadd10 pointer" onClick={()=>{ props.onClose(); }}>
                <span className="mdi mdi-close fs20 vam"></span>
                <span className="pleft5">Закрыть</span>
              </span>
            </div>
          </div>
          <div className="up12 splice">
            <div className="cell s-5 bg-w2-op50 pr" {...LeftZone.getRootProps()}>
              <FileBig openDialog={LeftZone.open} />
              <input {...LeftZone.getInputProps()}/>
              {compStore.replace_file.progress.active?(
                <div className="pa pa-tl w100 h100 up12 splice bg-w1">
                  <div className="cell s-12 s-middle">
                    <div className="hpadd20">
                      <div className="padd5 rad4 ofh bg-w1 pr">
                        <div className="pa pa-tl h100 bg-pc1 op50" style={{width:`${compStore.replace_file.progress.percent}%`}}></div>
                        <div className="pa pa-tl w100 h100 tac b1 fs11 lh12 ">
                          {compStore.replace_file.progress.percent}%
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ):null}
              {store.drag_over_left && compStore.getSelected().length === 1?(
                <div className="pa pa-tl w100 h100 dashed1 rad4 bg-w1">
                  <div className="up12 splice h100">
                    <div className="cell s-12 tac s-middle fs16">
                      Бросайте файл сюда, чтоб заменить выделенный фай
                    </div>
                  </div>
                </div>
              ):null}
            </div>
            <div className="cell s-7 pr" {...getRootProps()}>
              <div ref={(ref)=>{ if(ref) { _scrollerRef=ref; } }} className="ofa padd5" style={{height:549}}>
                <div className="up12 splice s-size-4">
                  {compStore.data.map((item, index)=>{
                    return (
                      <FileSmall key={index} index={index} item={item} />
                    );
                  })}
                </div>
              </div>

              <input {...getInputProps()}/>
              {store.drag_over?(
                <div className="pa pa-tl w100 h100 dashed1 rad4 bg-w1">
                  <div className="up12 splice h100">
                    <div className="cell s-12 tac s-middle fs16">
                      Бросайте файлы сюда, чтоб добавить их к галерее
                    </div>
                  </div>
                </div>
              ):null}

            </div>
          </div>

        </div>
      </Popup>
    </div>
  )
};

BigMode.defaultProps = {};

BigMode.propTypes = {}

export default observer(BigMode);
